import { useMutation } from "@apollo/client";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { ConfirmInboundDeliveryQuantitiesMutation } from "../../../graphql/deliveryService/mutations/confirmInboundDeliveryQuantities";
import { handleError } from "../../../utils/graphqlHelper";

interface ConfirmInboundDeliveryQuantitiesMutationProps {
  dataAction: (id: string) => void;
  errorAction?: () => void;
}

const useConfirmInboundDeliveryQuantitiesMutation = (
  props: ConfirmInboundDeliveryQuantitiesMutationProps,
) => {
  const { t } = useTranslation();
  const { dataAction, errorAction } = props;

  const mutation = useMutation(ConfirmInboundDeliveryQuantitiesMutation, {
    update: (cache, result) => {
      const data =
        result.data?.confirmInboundDeliveryQuantities.inboundDeliveryDetail;
      if (!data) return;

      const cacheId = cache.identify({
        __typename: "InboundDeliveryDetail",
        id: data.id,
      });
      cache.evict({ id: cacheId });
      cache.evict({ fieldName: "inboundDeliveries" });
      cache.gc();
    },
  });

  const { data, error } = mutation[1];

  const confirmedQuantityOutput =
    data?.confirmInboundDeliveryQuantities.inboundDeliveryDetail;

  useEffect(() => {
    if (!error) return;

    handleError(
      t("confirmInboundDeliveryQuantitiesError"),
      error.message,
      errorAction,
    );
  }, [error]);

  useEffect(() => {
    if (!data || !confirmedQuantityOutput) return;

    dataAction(confirmedQuantityOutput.id);
  }, [data]);

  return mutation;
};

export default useConfirmInboundDeliveryQuantitiesMutation;
